import { render } from "./MAOLoginPage.vue?vue&type=template&id=75d63272&scoped=true"
import script from "./MAOLoginPage.vue?vue&type=script&lang=js"
export * from "./MAOLoginPage.vue?vue&type=script&lang=js"

import "./MAOLoginPage.vue?vue&type=style&index=0&id=75d63272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d63272"]])

export default __exports__